import React, { Component } from "react";
import { connect } from "react-redux";
import QrReader from "react-qr-reader";
import icon from "../../static/azaumicon.png";
import coins from "../../static/coins.png";
import { message } from "antd";
import Axios from "axios";
import "./leaderboard.scss";

const mapDispatchToProps = (dispatch) => {
  return {};
};
class ConnectedLeaderboard extends Component {
  state = {
    delay: 1000,
    leaderboard: [],
    qr: "",
  };

  componentDidMount() {
    // setInterval(() => {
    //   this.setState({ errorQRs: [] });
    // }, 3000);
  }

  handleScan = async (data) => {
    console.log(data);
    if (data !== null) {
      try {
        const link = data;
        const url = new URL(link);
        const qr = url.searchParams.get("qr");

        await Axios.get("/1.0.0/game/leaderboard", { params: { qr: qr } })
          .then((response) => {
            this.setState({ leaderboard: response.data.leaderboard, qr: qr });
            /* setTimeout(() => {
              this.setState({ leaderboard: [] });
            }, 30000); */
          })
          .catch((err) => {
            console.log(err);
            message.error(
              "Hiba az adatok lekérése során kérem szennelje be újra a kódot!",
              5
            );
          });
      } catch (err) {
        console.log(err);
        message.error("Hibás QR kód!", 3);
      }
    }
  };

  handleError = (err) => {
    console.error(err);
  };

  render() {
    return (
      <div>
        <div className="leaderboard-title-container">
          <h1 className="leaderboard-title">Ranglista</h1>
        </div>
        <div className="leaderboard-container">
          <div className="leaderboard-qr-container">
            <div className="leaderboard-qr-title">
              <div className="leaderboard-qr-title-logo">
                <img alt="icon" src={icon} className="leaderboard-icon" />
              </div>
              <div className="leaderboard-qr-title-text">
                {this.state.leaderboard.length === 0
                  ? "Mutasd ide a QR-kódot!"
                  : "Mutatjuk hány ezüstöt gyűjtöttél!"}
              </div>
            </div>
            <div className="leaderboard-qr">
              <QrReader
                delay={this.state.delay}
                style={{
                  height: "100%",
                  width: "100%",
                }}
                onError={this.handleError}
                onScan={this.handleScan}
              />
            </div>
          </div>
          {this.state.leaderboard.length !== 0 && (
            <div className="leaderboard-list-container">
              {this.state.leaderboard.map((l) => {
                return (
                  <div
                    className={
                      l.qr === this.state.qr
                        ? "leaderboard-list-row leaderboard-list-row-selected"
                        : "leaderboard-list-row"
                    }
                    key={l.index}
                  >
                    <div className="leaderboard-name-index">
                      <div className="leaderboard-index">{l.index}.&nbsp;</div>
                      <div className="leaderboard-name"> {l.name}</div>
                    </div>
                    <div className="leaderboard-points-icon">
                      <div className="leaderboard-points">
                        {l.points === undefined || l.points === null
                          ? "0"
                          : l.points}
                      </div>
                      <div className="leaderboard-icon-container">
                        <img
                          alt="coin"
                          src={coins}
                          className="leaderboard-icon-img"
                        />
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});
const Leaderboard = connect(
  mapStateToProps,
  mapDispatchToProps
)(ConnectedLeaderboard);
export default Leaderboard;
